import * as Sentry from "@sentry/react";
import axios from "axios";
import { goBack, push } from "redux-first-history";
import { change } from "redux-form";
import _ from "underscore";
import type { GetGroupsResponse } from "@theirstory/common/api_types/backend";
import { createAction } from "@reduxjs/toolkit";

import type { ActionTypeHelper } from "../state/rootStore";

import { notifySuccess } from "./notify";
import { errorEntry } from "./prepare";
import { GROUP_ALL_NAMES_LOADED, GROUP_INVITE } from "./types";

// invite action used to invite people via email to groups
export const inviteToGroup = (groupId) => async (dispatch, getState) => {
  console.log(getState().form.groupCreate, getState().group_invites);
  let error = false;

  getState().group_invites.entries.forEach((invite, index) => {
    console.log(invite.value);
    if (invite.value.length > 0 && !validateEmail(invite.value)) {
      console.log("not a valid email", invite);
      dispatch(errorEntry(index, "not a valid email", GROUP_INVITE));
      error = true;
    }
  });

  if (error) {
    return;
  }

  const res = await axios.post(`/groups/${groupId}/invite`, {
    invites: _.pluck(getState().group_invites.entries, "value").filter((value) => value.trim().length > 0),
  });

  dispatch(notifySuccess(`Successfully sent invites to the group, ${res.data.name}`));
  dispatch(goBack());
};

// action to create a new group
export const createGroup =
  (modal = false) =>
  async (dispatch, getState) => {
    console.log(getState().form.groupCreate, getState().group_invites);
    let error = false;

    getState().group_invites.entries.forEach((invite, index) => {
      console.log(invite.value);
      if (invite.value.length > 0 && !validateEmail(invite.value)) {
        console.log("not a valid email", invite);
        dispatch(errorEntry(index, "not a valid email", GROUP_INVITE));
        error = true;
      }
    });

    if (error) {
      return;
    }

    const res = await axios.post("/groups/create", {
      ...getState().form.groupCreate.values,
      invites: _.pluck(getState().group_invites.entries, "value").filter((value) => value.trim().length > 0),
    });
    dispatch(getAllGroups());

    dispatch(notifySuccess(`Successfully created the group, ${res.data.name}`));

    if (!modal) {
      dispatch(push(`/groups/${res.data._id}`));
    }
  };

// action to edit a group
export const editGroup = (groupId, values) => async (dispatch) => {
  try {
    const res = await axios.put(`/groups/${groupId}/edit`, values);
    dispatch(getAllGroups());
    return res.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// action that accepts an invitation to a group
export const acceptGroupInvite = () => async (dispatch, getState) => {
  try {
    const { auth } = getState();
    const { search, pathname } = window.location;
    const urlParams = new URLSearchParams(search);
    const orgCode = urlParams.get("org_code");
    let pathRedirect = "/";
    if (!Object.keys(auth).length && orgCode) pathRedirect = "/signup";
    if (orgCode) dispatch(change("signup", "organizational_code", orgCode));
    const res = await axios.get(pathname);

    dispatch(notifySuccess(res.data));

    dispatch(getAllGroups());
    dispatch(push(pathRedirect));
  } catch (err) {
    Sentry.captureException(err);
    console.log(err.response);
  }
};

// checks to make sure what is entered is in an email format
function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

// responds with results of axios GET request /groups
// groups index
export const getAllGroups = (): ActionTypeHelper<Promise<void>> => async (dispatch) => {
  try {
    const res = await axios.get<GetGroupsResponse>("/groups");
    dispatch(groupNamesLoaded(res.data));
  } catch (err) {
    console.log(err);
    Sentry.captureException(err);
  }
};

export type GroupNamesLoaded = GetGroupsResponse;
export const groupNamesLoaded = createAction<GroupNamesLoaded>(GROUP_ALL_NAMES_LOADED);
